import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const INGREDIENTS_IMG = "https://images.unsplash.com/photo-1760445528267-25140a7bd31b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMG9saXZlJTIwb2lsJTIwaGVyYnMlMjBpbmdyZWRpZW50c3xlbnwwfHx8fDE3NzI1NjY5ODF8MA&ixlib=rb-4.1.0&q=85";

export const AboutSection = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="histoire"
      data-testid="about-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <p
              className="text-sm uppercase tracking-[0.3em] text-[#C1624D] mb-4"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {t("about.label")}
            </p>
            <h2
              className="text-4xl md:text-5xl font-light tracking-tight text-[#2C2420] mb-8 leading-[1.1]"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              data-testid="about-heading"
            >
              {t("about.heading_1")}<br />
              {t("about.heading_2")}
            </h2>
            <div className="space-y-5 text-[#5D544F] leading-relaxed" style={{ fontFamily: "'Lato', sans-serif" }}>
              <p className="text-base md:text-lg">{t("about.p1")}</p>
              <p className="text-base md:text-lg">{t("about.p2")}</p>
            </div>

            <div className="mt-10 flex items-center gap-8">
              <div>
                <p className="text-3xl font-light text-[#C1624D]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>100%</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#8C847F] mt-1" style={{ fontFamily: "'Lato', sans-serif" }}>{t("about.feature_local")}</p>
              </div>
              <div className="w-px h-12 bg-[#D8D0C5]" />
              <div>
                <p className="text-3xl font-light text-[#6F7D4E]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Local</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#8C847F] mt-1" style={{ fontFamily: "'Lato', sans-serif" }}>{t("about.feature_handmade")}</p>
              </div>
              <div className="w-px h-12 bg-[#D8D0C5]" />
              <div>
                <p className="text-3xl font-light text-[#A5C4D4]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Saison</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#8C847F] mt-1" style={{ fontFamily: "'Lato', sans-serif" }}>{t("about.feature_seasonal")}</p>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-sm">
              <img
                src={INGREDIENTS_IMG}
                alt="Ingrédients frais du marché provençal"
                className="w-full h-[400px] lg:h-[520px] object-cover"
                data-testid="about-image"
              />
            </div>
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-2 border-[#C1624D]/30 rounded-sm -z-10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
